import { render, staticRenderFns } from "./RegraFiscalDetalhes.vue?vue&type=template&id=26e95c5e"
import script from "./RegraFiscalDetalhes.vue?vue&type=script&lang=js"
export * from "./RegraFiscalDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports